import { Helmet } from "react-helmet";
import Navigation from "@/components/Navigation";
import { Card } from "@/components/ui/card";
import { Mail } from "lucide-react";

const Contacto = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Contacto - Midstino</title>
        <meta name="description" content="Contáctanos para cualquier consulta sobre horóscopo y tarot" />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-8 bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
            Contacto
          </h1>
          
          <Card className="p-8 text-center">
            <Mail className="w-16 h-16 mx-auto mb-6 text-primary" />
            <h2 className="text-2xl font-semibold mb-4 text-foreground">Correo Electrónico</h2>
            <a 
              href="mailto:contacto@midstino.com" 
              className="text-xl text-primary hover:text-primary/80 transition-colors font-medium"
            >
              contacto@midstino.com
            </a>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default Contacto;
